import './InfoPanelsInput.scss';

export default function InfoPanelsInput(props) {
    const divError = (props.fpStates?.errors[props.fieldName]) ? "error" : "";
    const fieldValue = props.value || props.fpStates.fieldValues[props.fieldName];

    return (
        <div className="infopanelinput">
            <input className={divError} type={props.type} readOnly={true} value={fieldValue} />
        </div>
    )
}